import React from "react";
import { connect } from "react-redux";
import routes from "../../../assets/apiRoutes.json"
import axios from "axios";
import { GridLayout } from "../../../common/GridLayout";

import DataGrid, {
  Column,
  Editing,
  Paging,
  Selection,
  Toolbar,
  Item,
  FilterRow,
  FilterPanel,
  FilterBuilderPopup,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnFixing,
  Sorting,
  Export,
  Pager,
  HeaderFilter,
  StateStoring
} from 'devextreme-react/data-grid';

import { Button } from 'devextreme-react/button';
import { alert } from 'devextreme/ui/dialog';
import { confirm } from 'devextreme/ui/dialog';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";

const filterBuilderPopupPosition = {
  of: window,
  at: 'top',
  my: 'top',
  offset: { y: 10 },
};

const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
const dataGrid = React.createRef();
let accessToken = '';

const gridKey = "cdf6eb25-b990-4d16-97e8-ae34ac681f66";
const loadState = () => {return GridLayout.sendStorageRequest(gridKey, "GET", accessToken);}

class EditSeedsPerCell extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedItemKeys: [],
      currentLayout: "Default",
    };

    accessToken = props.oidc.user.access_token;
    this.selectionChanged = this.selectionChanged.bind(this);
    this.deleteRecords = this.deleteRecords.bind(this);
    this.onContentReady = this.onContentReady.bind(this);
    this.seedPerCellEditorOptions = {
      format: {
        type: "fixedPoint",
        precision: 2
      }
    };
    this.dataSource = createStore({
      key: 'rowid',
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.maintenance.AllSeedsPerCells}`,
      insertUrl: `${window._env_.REACT_APP_APIS}/${routes.maintenance.InsertSeedsPerCell}`,
      updateUrl: `${window._env_.REACT_APP_APIS}/${routes.maintenance.UpdateSeedsPerCell}`,
      deleteUrl: `${window._env_.REACT_APP_APIS}/${routes.maintenance.DeleteSeedsPerCell}`,
      onBeforeSend: function(method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });
  }
  setCurrentLayout =(value)=>{
    this.setState({
      currentLayout:value
    })
  }
  saveState=(state)=> { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, this.state.currentLayout);}
  render() {
    return (
      <div className="h-100 m-0" style={{ height: '100%', overflowY: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <DataGrid
          style={{ flex: '1 1 auto', minHeight: 0 }}

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }} id="gridContainer"
          onContentReady={this.onContentReady}
          ref={dataGrid}
          showBorders={true}
          className="ATConfigurationGridStyle"
          selectedRowKeys={this.state.selectedItemKeys}
          onSelectionChanged={this.selectionChanged}
          rowAlternationEnabled={true}
          allowColumnReordering={true}
          columnAutoWidth={true}
        >
          <Selection mode="multiple" />
          <Paging
            enabled={true}
          />
          <Pager
            visible={true}
            showPageSizeSelector={true}
            allowedPageSizes={allowedPageSizes}
            showNavigationButtons={true}
            showInfo={true}
          />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <FilterBuilderPopup position={filterBuilderPopupPosition} />
          <ColumnChooser
            enabled={true}
            title="Choose Column"
            width={290}
            height={290}
            sortOrder="asc"
          >
            <ColumnChooserSearch
              enabled={true}
              editorOptions={{ placeholder: 'Search column' }} />
          </ColumnChooser>
          <HeaderFilter visible={true} />
          <ColumnFixing enabled={true}/>,
          <Export enabled={true} allowExportSelectedData={true} text="Export" />
          <Sorting mode="multiple"/>,
          <Editing
            mode="cell"
            newRowPosition="first"
            refreshMode="repaint"
            allowUpdating={true}
            allowAdding={true}
            allowDeleting={true} />
          <StateStoring
            enabled={true}
            type="custom"
            customLoad={loadState}
            storageKey={gridKey}
            customSave={this.saveState}
          />
          <Column dataField="speciescode" caption="Species Code"  />
          <Column dataField="celltype"  caption="Cell Type"  />
          <Column dataField="keycode"  caption="Key Code" allowEditing={false} cssClass="column-readonly"  />
          <Column dataField="cellsize" dataType="number" caption="Cell Size"  />
          <Column dataField="logerm" dataType="number" caption="Lo Germ"  />
          <Column dataField="higerm" dataType="number" caption="Hi Germ"  />
          <Column dataField="germrange" caption="Germ Range" allowEditing={false} cssClass="column-readonly"  />
          <Column dataField="seedpercell" dataType="number" caption="Seeds per Cell" editorOptions={this.seedPerCellEditorOptions}  />
          <Toolbar>
            <Item name="addRowButton"/>
            <Item>
              <Button
                onClick={this.deleteRecords}
                icon="trash"
                disabled={!this.state.selectedItemKeys.length}/>
            </Item>
            <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={this.setCurrentLayout} />
                 </Item>
            <Item name="exportButton" />
            <Item name="columnChooserButton" />
          </Toolbar>
        </DataGrid>
      </div>
    );
  }

  onContentReady(e) {
    if (!e.component._hasLoaded) {
      e.component._hasLoaded = true;
      e.component.option("dataSource", this.dataSource);
    }
  }

  deleteRecords()
  {
    var that = this;
    let result = confirm("<i>Are your sure you want to delete selected records?</i>", "Delete");
    result.then((dialogResult) => {
        if(dialogResult)
        {
          dataGrid.current.instance().beginCustomLoading("Deleting");
          axios.post
          (
            `${window._env_.REACT_APP_APIS}/${routes.maintenance.DeleteSeedsPerCells}`,
            that.state.selectedItemKeys,
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
              },
            }
          )
          .then((res) => {
            dataGrid.current.instance().endCustomLoading();
            dataGrid.current.instance().refresh();
          })
          .catch((err) => {
            dataGrid.current.instance().endCustomLoading();
            alert(err, "Error");
          });

        }
    });

  }

  selectionChanged(data) {
    this.setState({
      selectedItemKeys: data.selectedRowKeys,
    });
  }
}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(EditSeedsPerCell);
